import { render, staticRenderFns } from "./V2DealMatrix.vue?vue&type=template&id=618f6f74&scoped=true&"
import script from "./V2DealMatrix.vue?vue&type=script&lang=js&"
export * from "./V2DealMatrix.vue?vue&type=script&lang=js&"
import style0 from "./V2DealMatrix.vue?vue&type=style&index=0&id=618f6f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f6f74",
  null
  
)

export default component.exports